import React, { useEffect } from 'react'
import useBVNStore from '../../../state/BVN.store'
import useMotorStore from '../../../state/Motor.store'
import { MotorDetails } from './details'
import { Enter } from './enter-details'
import { Motor } from './motor'
import { MotorPayment } from './payment'
import { MotorPolicy } from './policy'
import { MotorSummary } from './summary'
import { screens } from './types'

const MotorIndex = () => {
  const [screen, reset] = useMotorStore((state) => [state.screen, state.reset])
  const [bReset] = useBVNStore((state) => [state.reset])
  useEffect(() => {
    reset()
  }, [reset, bReset])

  switch (screen) {
    case screens.ENTER_PLATE: {
      return <Motor />
    }
    case screens.MOTOR_PAYMENT: {
      return <MotorPayment />
    }
    case screens.MOTOR_POLICY: {
      return <MotorPolicy />
    }
    case screens.MOTOR_SUMMARY: {
      return <MotorSummary />
    }
    case screens.ENTER_DETAILS: {
      return <Enter />
    }
    case screens.MOTOR_DETAILS: {
      return <MotorDetails />
    }
    default:
      return <Motor />
  }
}

export { MotorIndex }
